export default class PropTransformer {
}
//# sourceMappingURL=PropTransformer.js.map